import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

const UnsavedChangesDialog = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>¿Descartar cambios?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Tienes cambios sin guardar. ¿Estás seguro de que deseas cerrar el editor sin guardar?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancelar
      </Button>
      <Button onClick={onConfirm} color="secondary" variant="contained">
        Descartar cambios
      </Button>
    </DialogActions>
  </Dialog>
);

export default UnsavedChangesDialog;
